if (!customElements.get('product-description-toggle')) {
  customElements.define(
    'product-description-toggle',
    class ProductDescriptionToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.mp-description-toggle__button');
        if (!this.button || this.hasToggleHandler) return;

        this.button.addEventListener('click', () => this.toggleDescription());
        this.hasToggleHandler = true;
      }

      toggleDescription() {
        const expanded = this.button.getAttribute('aria-expanded') === 'true';
        this.button.setAttribute('aria-expanded', String(!expanded));
        this.toggleAttribute('data-expanded', !expanded);
        this.button.querySelector('[data-collapsed-label]').hidden = !expanded;
        this.button.querySelector('[data-expanded-label]').hidden = expanded;
      }
    }
  );
}
